import {authRouteConfig} from 'pages/auth';
import DashboardSelector from 'pages/uiwisePages/Dashboard/DashboardSelector';
import {Navigate} from 'react-router-dom';
import {BUSINESS_ROLE, initialUrl} from 'shared/constants/AppConst';
import {staticPagesConfigs} from '../../pages/staticPages';
import RoleGuard from './RoleGuard';

const commonRoutes = [...staticPagesConfigs, ...authRouteConfig];

const anonymousStructure = {
  routes: [
    {
      path: '/',
      element: <Navigate to={initialUrl} />,
      permittedrole: BUSINESS_ROLE.PUBLIC,
    },
    {
      path: '*',
      element: <Navigate to='/signin' />,
      permittedrole: BUSINESS_ROLE.PUBLIC,
    },
  ],
};

const authorizedStructure = (customRoutes, userRole) => {
  return {
    routes: [
      {
        path: '/',
        element: (
          <RoleGuard
            permittedrole={BUSINESS_ROLE.BUSINESS_USER}
            userRole={userRole}
          >
            <DashboardSelector />
          </RoleGuard>
        ),
      },
      {
        path: '/dashboard',
        element: (
          <RoleGuard
            permittedrole={BUSINESS_ROLE.BUSINESS_USER}
            userRole={userRole}
          >
            <DashboardSelector />
          </RoleGuard>
        ),
      },
      ...customRoutes.map((route) => ({
        ...route,
        element: (
          <RoleGuard permittedrole={route.permittedrole} userRole={userRole}>
            {route.element}
          </RoleGuard>
        ),
      })),
    ],
  };
};

export const generateRoutes = (structure) => {
  const {
    isAuthenticated = false,
    customRoutes = [],
    userRole,
  } = structure || {};

  const applicableRoutes = isAuthenticated
    ? authorizedStructure(customRoutes, userRole).routes
    : anonymousStructure.routes;

  return [...commonRoutes, ...applicableRoutes];
};
